import { ComponentPropsWithoutRef } from 'react';

export function Code403(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="783" height="1080" viewBox="0 0 783 1080" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M211.731 596.227V630.924H177.776V689H141.038V630.924H7.62988V606.246L104.114 422.926H145.12L53.6455 596.227H141.038V514.215H177.776V596.227H211.731Z"
        fill="#9E8AD9"
      />
      <path
        d="M374.001 687.605C352.362 687.585 331.083 681.95 312.146 671.227C293.209 660.504 277.232 645.04 265.707 626.28C254.181 607.52 247.482 586.075 246.235 563.946C244.988 541.816 249.234 519.723 258.575 499.729C259.307 498.151 260.621 496.934 262.228 496.347C263.835 495.761 265.603 495.851 267.145 496.599C268.687 497.347 269.876 498.692 270.45 500.338C271.025 501.983 270.938 503.795 270.21 505.375C262.646 521.298 258.769 538.792 258.881 556.5C258.882 579.9 265.659 602.774 278.355 622.226C291.052 641.678 309.097 656.834 330.206 665.774C351.315 674.714 374.538 677.038 396.938 672.45C419.336 667.862 439.903 656.569 456.032 640.001C472.162 623.432 483.132 602.334 487.551 579.376C491.97 556.418 489.64 532.633 480.857 511.032C472.074 489.431 457.232 470.985 438.21 458.03C419.189 445.074 396.842 438.192 374.001 438.254C350.936 438.113 328.387 445.229 309.399 458.642C307.978 459.598 306.244 459.937 304.579 459.584C302.914 459.231 301.454 458.215 300.52 456.76C299.586 455.304 299.255 453.528 299.6 451.822C299.944 450.116 300.936 448.62 302.357 447.664C321.637 434.413 344.068 426.775 367.255 425.565C390.441 424.354 413.514 429.617 434.009 440.791C454.503 451.965 471.652 468.632 483.622 489.01C495.594 509.389 501.938 532.715 501.978 556.5C501.889 591.243 488.378 624.537 464.396 649.104C440.415 673.672 407.915 687.514 374.001 687.605Z"
        fill="#9E8AD9"
      />
      <path
        d="M373.983 659.695C354.06 659.695 334.586 653.643 318.021 642.304C301.456 630.965 288.545 614.849 280.922 595.994C273.298 577.138 271.303 556.39 275.189 536.373C279.076 516.356 288.67 497.969 302.757 483.537C316.844 469.106 334.792 459.278 354.332 455.296C373.871 451.315 394.124 453.358 412.53 461.168C430.936 468.979 446.667 482.205 457.735 499.174C468.804 516.144 474.712 536.095 474.712 556.504C474.714 557.37 474.549 558.228 474.226 559.029C473.904 559.83 473.431 560.557 472.833 561.17C472.236 561.783 471.527 562.269 470.745 562.601C469.965 562.933 469.128 563.104 468.282 563.104C467.436 563.104 466.6 562.933 465.819 562.601C465.038 562.269 464.328 561.783 463.731 561.17C463.134 560.557 462.661 559.83 462.338 559.029C462.016 558.228 461.851 557.37 461.852 556.504C461.852 538.701 456.699 521.296 447.044 506.493C437.389 491.69 423.665 480.152 407.609 473.339C391.553 466.526 373.885 464.743 356.84 468.216C339.795 471.69 324.138 480.263 311.849 492.852C299.561 505.441 291.192 521.481 287.801 538.943C284.411 556.404 286.151 574.503 292.802 590.952C299.452 607.401 310.715 621.459 325.165 631.351C339.615 641.242 356.604 646.522 373.983 646.522C388.4 646.588 402.606 642.983 415.326 636.029C428.045 629.076 438.878 618.993 446.85 606.688C447.313 605.967 447.909 605.346 448.606 604.862C449.302 604.377 450.085 604.037 450.909 603.863C451.734 603.688 452.584 603.681 453.411 603.844C454.238 604.005 455.025 604.332 455.729 604.806C456.433 605.28 457.038 605.891 457.512 606.604C457.985 607.317 458.316 608.12 458.487 608.964C458.658 609.809 458.664 610.679 458.506 611.527C458.348 612.374 458.028 613.18 457.566 613.902C448.378 627.981 435.946 639.525 421.367 647.512C406.789 655.498 390.515 659.683 373.983 659.695Z"
        fill="#9E8AD9"
      />
      <path
        d="M373.995 632.085C364.307 632.127 354.709 630.177 345.769 626.353C336.829 622.528 328.728 616.905 321.947 609.817C311.648 599.234 304.636 585.766 301.791 571.109C298.947 556.453 300.398 541.262 305.962 527.447C311.526 513.634 320.954 501.815 333.06 493.477C345.165 485.14 359.408 480.657 373.995 480.593C383.684 480.552 393.282 482.501 402.222 486.326C411.162 490.151 419.262 495.774 426.044 502.862C426.626 503.46 427.089 504.169 427.405 504.949C427.72 505.729 427.883 506.566 427.883 507.41C427.883 508.255 427.72 509.091 427.405 509.872C427.089 510.652 426.626 511.361 426.044 511.958C425.461 512.556 424.769 513.029 424.007 513.352C423.244 513.676 422.428 513.842 421.604 513.842C420.779 513.842 419.963 513.676 419.201 513.352C418.44 513.029 417.748 512.555 417.165 511.958C411.506 506.145 404.775 501.542 397.364 498.419C389.952 495.296 382.009 493.714 373.995 493.767C357.835 493.806 342.335 500.338 330.826 511.958C322.269 520.688 316.438 531.825 314.073 543.957C311.708 556.088 312.915 568.666 317.54 580.092C322.166 591.52 330.002 601.281 340.054 608.137C350.105 614.993 361.92 618.634 373.995 618.599C382.997 618.623 391.893 616.605 400.044 612.688C408.194 608.772 415.397 603.055 421.133 595.948C426.871 588.841 431.001 580.521 433.226 571.584C435.451 562.648 435.716 553.318 434.004 544.264C433.841 543.44 433.839 542.591 433.998 541.765C434.156 540.94 434.472 540.156 434.927 539.456C435.381 538.755 435.966 538.154 436.649 537.686C437.33 537.218 438.095 536.891 438.9 536.727C439.706 536.561 440.535 536.561 441.34 536.725C442.144 536.888 442.91 537.213 443.594 537.68C444.276 538.147 444.862 538.747 445.318 539.447C445.774 540.145 446.091 540.93 446.25 541.755C448.591 553.879 447.971 566.407 444.445 578.226C440.92 590.046 434.598 600.79 426.044 609.503C419.32 616.692 411.238 622.402 402.289 626.285C393.341 630.167 383.713 632.141 373.995 632.085Z"
        fill="#9E8AD9"
      />
      <path
        d="M373.988 601.043C365.423 601.079 357.041 598.505 349.908 593.649C342.776 588.792 337.215 581.871 333.932 573.767C330.65 565.664 329.794 556.742 331.475 548.139C333.156 539.535 337.297 531.639 343.371 525.453C344.549 524.247 346.145 523.569 347.81 523.569C349.476 523.569 351.073 524.247 352.25 525.453C353.428 526.659 354.088 528.296 354.088 530.001C354.088 531.706 353.428 533.343 352.25 534.549C347.155 539.875 344.093 546.895 343.618 554.337C343.144 561.779 345.288 569.148 349.664 575.108C354.038 581.068 360.353 585.224 367.463 586.823C374.573 588.421 382.007 587.356 388.417 583.821C394.826 580.286 399.786 574.514 402.396 567.553C405.008 560.592 405.097 552.903 402.648 545.881C400.199 538.858 395.374 532.967 389.048 529.277C382.723 525.587 375.316 524.341 368.171 525.767C366.548 526.096 364.864 525.752 363.489 524.811C362.113 523.87 361.158 522.408 360.834 520.746C360.509 519.084 360.842 517.359 361.758 515.948C362.675 514.537 364.1 513.556 365.722 513.221C371.651 512.018 377.761 512.101 383.658 513.465C389.555 514.829 395.106 517.443 399.957 521.14C404.807 524.836 408.847 529.532 411.817 534.925C414.788 540.319 416.622 546.29 417.203 552.454C417.783 558.618 417.096 564.839 415.186 570.714C413.277 576.59 410.187 581.99 406.115 586.568C402.044 591.145 397.082 594.798 391.548 597.291C386.015 599.784 380.033 601.062 373.988 601.043Z"
        fill="#9E8AD9"
      />
      <path
        d="M588.692 535.924L659.015 457.994H540.821V422.926H711.339V448.16L634.708 529.43C636.687 529.182 639.594 529.059 643.429 529.059C664.334 529.059 681.837 536.233 695.938 550.582C710.04 564.807 717.091 582.805 717.091 604.576C717.091 630.429 708.37 651.581 690.929 668.033C673.611 684.485 651.531 692.711 624.688 692.711C601.681 692.711 581.518 686.217 564.2 673.229C547.006 660.24 536.43 643.603 532.472 623.316L565.499 611.812C568.344 624.924 575.333 635.81 586.466 644.469C597.599 653.128 610.34 657.457 624.688 657.457C640.646 657.457 653.757 652.447 664.024 642.428C674.291 632.285 679.425 619.42 679.425 603.834C679.425 588.99 674.415 577.177 664.396 568.395C654.376 559.612 641.821 555.221 626.729 555.221C618.194 555.221 609.412 556.767 600.382 559.859L588.692 535.924Z"
        fill="#9E8AD9"
      />
      <g filter="url(#filter0_d_2361_6318)">
        <path
          d="M372.996 754.515C483.174 754.515 572.381 665.637 572.246 556C572.11 446.363 482.683 357.485 372.505 357.485C262.327 357.485 173.12 446.363 173.255 556C173.391 665.637 262.818 754.515 372.996 754.515Z"
          fill="#F2F0FF"
          fillOpacity="0.13"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2361_6318)">
        <path
          d="M4.5 625.5C4.5 608.931 17.9315 595.5 34.5 595.5H116.5C133.069 595.5 146.5 608.931 146.5 625.5V657.5H34.5C17.9315 657.5 4.5 644.069 4.5 627.5V625.5Z"
          fill="url(#paint0_linear_2361_6318)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_d_2361_6318)">
        <path
          d="M442.5 791.5H550.5C567.621 791.5 581.5 805.379 581.5 822.5C581.5 839.621 567.621 853.5 550.5 853.5H482.5C460.409 853.5 442.5 835.591 442.5 813.5V791.5Z"
          fill="url(#paint1_linear_2361_6318)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter3_d_2361_6318)">
        <path
          d="M452.5 279.5C452.5 262.931 465.931 249.5 482.5 249.5H608.5C625.069 249.5 638.5 262.931 638.5 279.5V281.5C638.5 298.069 625.069 311.5 608.5 311.5H452.5V279.5Z"
          fill="url(#paint2_linear_2361_6318)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <mask id="path-11-inside-1_2361_6318" fill="white">
        <path d="M534.676 503.376C536.777 502.694 539.038 503.844 539.671 505.96C546.794 529.754 548.755 554.795 545.423 579.408C545.127 581.597 543.072 583.084 540.89 582.738L478.132 572.773C475.95 572.426 474.47 570.377 474.732 568.184C476.335 554.73 475.267 541.091 471.589 528.051C470.989 525.925 472.132 523.671 474.233 522.989L534.676 503.376Z" />
      </mask>
      <path
        d="M534.676 503.376C536.777 502.694 539.038 503.844 539.671 505.96C546.794 529.754 548.755 554.795 545.423 579.408C545.127 581.597 543.072 583.084 540.89 582.738L478.132 572.773C475.95 572.426 474.47 570.377 474.732 568.184C476.335 554.73 475.267 541.091 471.589 528.051C470.989 525.925 472.132 523.671 474.233 522.989L534.676 503.376Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-11-inside-1_2361_6318)"
      />
      <mask id="path-12-inside-2_2361_6318" fill="white">
        <path d="M540.942 582.41C543.125 582.752 544.621 584.8 544.229 586.974C539.821 611.416 530.245 634.637 516.142 655.082C514.888 656.9 512.383 657.298 510.593 656.002L459.126 618.732C457.337 617.436 456.944 614.939 458.169 613.101C465.684 601.827 470.899 589.18 473.516 575.886C473.943 573.719 475.982 572.225 478.164 572.567L540.942 582.41Z" />
      </mask>
      <path
        d="M540.942 582.41C543.125 582.752 544.621 584.8 544.229 586.974C539.821 611.416 530.245 634.637 516.142 655.082C514.888 656.9 512.383 657.298 510.593 656.002L459.126 618.732C457.337 617.436 456.944 614.939 458.169 613.101C465.684 601.827 470.899 589.18 473.516 575.886C473.943 573.719 475.982 572.225 478.164 572.567L540.942 582.41Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-12-inside-2_2361_6318)"
      />
      <mask id="path-13-inside-3_2361_6318" fill="white">
        <path d="M510.566 656.041C512.354 657.337 512.757 659.841 511.421 661.6C496.39 681.373 477.312 697.71 455.461 709.518C453.518 710.568 451.105 709.784 450.1 707.817L421.179 651.235C420.173 649.268 420.957 646.865 422.884 645.784C434.699 639.154 445.09 630.256 453.46 619.602C454.825 617.864 457.32 617.46 459.109 618.756L510.566 656.041Z" />
      </mask>
      <path
        d="M510.566 656.041C512.354 657.337 512.757 659.841 511.421 661.6C496.39 681.373 477.312 697.71 455.461 709.518C453.518 710.568 451.105 709.784 450.1 707.817L421.179 651.235C420.173 649.268 420.957 646.865 422.884 645.784C434.699 639.154 445.09 630.256 453.46 619.602C454.825 617.864 457.32 617.46 459.109 618.756L510.566 656.041Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-13-inside-3_2361_6318)"
      />
      <mask id="path-14-inside-4_2361_6318" fill="white">
        <path d="M450.639 707.54C451.652 709.504 450.883 711.921 448.896 712.888C426.566 723.762 402.171 729.743 377.344 730.433C375.136 730.494 373.336 728.707 373.325 726.498L373.017 662.954C373.007 660.745 374.79 658.953 376.997 658.857C390.533 658.265 403.819 655.007 416.094 649.27C418.095 648.335 420.505 649.098 421.517 651.062L450.639 707.54Z" />
      </mask>
      <path
        d="M450.639 707.54C451.652 709.504 450.883 711.921 448.896 712.888C426.566 723.762 402.171 729.743 377.344 730.433C375.136 730.494 373.336 728.707 373.325 726.498L373.017 662.954C373.007 660.745 374.79 658.953 376.997 658.857C390.533 658.265 403.819 655.007 416.094 649.27C418.095 648.335 420.505 649.098 421.517 651.062L450.639 707.54Z"
        fill="#6A52B7"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-14-inside-4_2361_6318)"
      />
      <path
        d="M466.467 439.357C465.708 440.379 464.743 440.973 463.573 441.141C462.399 441.305 461.325 441.025 460.35 440.301C459.374 439.576 458.798 438.63 458.62 437.461C458.442 436.292 458.733 435.197 459.492 434.175C459.956 433.551 460.528 433.091 461.211 432.795C461.895 432.495 462.596 432.393 463.314 432.488L463.218 433.344C462.649 433.252 462.087 433.324 461.533 433.56C460.979 433.795 460.516 434.162 460.146 434.66C459.521 435.501 459.283 436.392 459.43 437.333C459.58 438.272 460.053 439.037 460.849 439.628C461.646 440.22 462.515 440.452 463.456 440.324C464.398 440.197 465.182 439.711 465.809 438.867C466.181 438.366 466.402 437.817 466.47 437.22C466.536 436.621 466.441 436.065 466.186 435.549L466.964 435.2C467.267 435.853 467.376 436.555 467.291 437.304C467.205 438.049 466.931 438.733 466.467 439.357ZM470.364 433.865L462.166 430.811L462.697 430.096L469.762 432.76L465.238 426.677L465.825 425.886L472.955 428.461L468.365 422.467L468.896 421.752L474.187 428.719L473.586 429.528L466.42 426.942L470.965 433.056L470.364 433.865ZM476.292 424.56L478.727 421.282L479.362 421.753L476.427 425.704L469.682 420.694L472.579 416.795L473.219 417.27L470.822 420.496L473.206 422.268L475.425 419.281L476.065 419.756L473.846 422.743L476.292 424.56ZM477.555 418.615L476.939 418.157L479.514 414.691L480.13 415.149L477.555 418.615ZM478.054 409.424L478.481 408.85L485.225 413.861L484.726 414.534L478.724 410.075L478.054 411.92L477.346 411.665L478.054 409.424ZM486.085 412.704L485.478 412.253L484.835 408.009C484.657 406.801 484.32 406.014 483.825 405.645C483.395 405.326 482.961 405.21 482.521 405.297C482.082 405.385 481.724 405.615 481.446 405.988C480.932 406.681 480.876 407.421 481.28 408.207L480.518 408.525C480.26 408.002 480.159 407.479 480.216 406.957C480.272 406.429 480.464 405.944 480.793 405.502C481.193 404.963 481.727 404.625 482.394 404.487C483.059 404.344 483.704 404.505 484.328 404.968C484.72 405.259 485.015 405.649 485.212 406.136C485.407 406.621 485.555 407.211 485.658 407.905L486.147 411.254L488.614 407.933L489.268 408.419L486.085 412.704ZM491.4 401.404L492.034 401.876L491.388 402.746L492.738 403.749L492.238 404.421L490.888 403.418L488.24 406.984L487.605 406.512L484.707 400.469L485.256 399.73L488.157 405.769L490.253 402.947L488.193 401.416L488.693 400.744L490.753 402.274L491.4 401.404Z"
        fill="#FBFDFF"
      />
      <path
        d="M372.5 456.5C372.5 454.291 374.292 452.492 376.499 452.577C396.946 453.368 416.733 460.204 433.336 472.267C449.938 484.329 462.555 501.036 469.625 520.237C470.388 522.31 469.231 524.57 467.13 525.253L434.38 535.894C432.279 536.576 430.035 535.42 429.216 533.369C424.953 522.683 417.745 513.392 408.393 506.597C399.042 499.803 387.977 495.819 376.497 495.066C374.293 494.921 372.5 493.144 372.5 490.935L372.5 456.5Z"
        fill="#9E8AD9"
        stroke="#483389"
      />
      <mask id="path-17-inside-5_2361_6318" fill="white">
        <path d="M467.091 525.133C469.191 524.448 471.457 525.593 472.061 527.718C476.151 542.116 477.074 557.245 474.746 572.062C472.211 588.197 465.894 603.504 456.31 616.73C446.726 629.956 434.148 640.726 419.604 648.16C406.249 654.986 391.585 658.82 376.63 659.418C374.422 659.506 372.628 657.709 372.626 655.5L372.582 621.065C372.579 618.856 374.37 617.076 376.574 616.929C384.829 616.377 392.9 614.152 400.292 610.374C408.872 605.988 416.293 599.634 421.948 591.831C427.602 584.027 431.33 574.997 432.825 565.477C434.113 557.276 433.714 548.913 431.668 540.897C431.122 538.757 432.255 536.501 434.355 535.816L467.091 525.133Z" />
      </mask>
      <path
        d="M467.091 525.133C469.191 524.448 471.457 525.593 472.061 527.718C476.151 542.116 477.074 557.245 474.746 572.062C472.211 588.197 465.894 603.504 456.31 616.73C446.726 629.956 434.148 640.726 419.604 648.16C406.249 654.986 391.585 658.82 376.63 659.418C374.422 659.506 372.628 657.709 372.626 655.5L372.582 621.065C372.579 618.856 374.37 617.076 376.574 616.929C384.829 616.377 392.9 614.152 400.292 610.374C408.872 605.988 416.293 599.634 421.948 591.831C427.602 584.027 431.33 574.997 432.825 565.477C434.113 557.276 433.714 548.913 431.668 540.897C431.122 538.757 432.255 536.501 434.355 535.816L467.091 525.133Z"
        fill="#9E8AD9"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-17-inside-5_2361_6318)"
      />
      <mask
        id="mask0_2361_6318"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="179"
        y="210"
        width="603"
        height="4"
      >
        <circle cx="780.5" cy="212.241" r="1.5" transform="rotate(-180 780.5 212.241)" fill="#F24C84" />
        <circle cx="772.405" cy="212.241" r="1.5" transform="rotate(-180 772.405 212.241)" fill="#F24C84" />
        <circle cx="764.311" cy="212.241" r="1.5" transform="rotate(-180 764.311 212.241)" fill="#F24C84" />
        <circle cx="756.216" cy="212.241" r="1.5" transform="rotate(-180 756.216 212.241)" fill="#F24C84" />
        <circle cx="748.122" cy="212.241" r="1.5" transform="rotate(-180 748.122 212.241)" fill="#F24C84" />
        <circle cx="740.027" cy="212.241" r="1.5" transform="rotate(-180 740.027 212.241)" fill="#F24C84" />
        <circle cx="731.933" cy="212.241" r="1.5" transform="rotate(-180 731.933 212.241)" fill="#F24C84" />
        <circle cx="723.838" cy="212.241" r="1.5" transform="rotate(-180 723.838 212.241)" fill="#F24C84" />
        <circle cx="715.743" cy="212.241" r="1.5" transform="rotate(-180 715.743 212.241)" fill="#F24C84" />
        <circle cx="707.648" cy="212.241" r="1.5" transform="rotate(-180 707.648 212.241)" fill="#F24C84" />
        <circle cx="699.554" cy="212.241" r="1.5" transform="rotate(-180 699.554 212.241)" fill="#F24C84" />
        <circle cx="691.459" cy="212.241" r="1.5" transform="rotate(-180 691.459 212.241)" fill="#F24C84" />
        <circle cx="683.365" cy="212.241" r="1.5" transform="rotate(-180 683.365 212.241)" fill="#F24C84" />
        <circle cx="675.27" cy="212.241" r="1.5" transform="rotate(-180 675.27 212.241)" fill="#F24C84" />
        <circle cx="667.176" cy="212.241" r="1.5" transform="rotate(-180 667.176 212.241)" fill="#F24C84" />
        <circle cx="659.081" cy="212.241" r="1.5" transform="rotate(-180 659.081 212.241)" fill="#F24C84" />
        <circle cx="650.986" cy="212.241" r="1.5" transform="rotate(-180 650.986 212.241)" fill="#F24C84" />
        <circle cx="642.892" cy="212.241" r="1.5" transform="rotate(-180 642.892 212.241)" fill="#F24C84" />
        <circle cx="634.797" cy="212.241" r="1.5" transform="rotate(-180 634.797 212.241)" fill="#F24C84" />
        <circle cx="626.703" cy="212.241" r="1.5" transform="rotate(-180 626.703 212.241)" fill="#F24C84" />
        <circle cx="618.608" cy="212.241" r="1.5" transform="rotate(-180 618.608 212.241)" fill="#F24C84" />
        <circle cx="610.514" cy="212.241" r="1.5" transform="rotate(-180 610.514 212.241)" fill="#F24C84" />
        <circle cx="602.419" cy="212.241" r="1.5" transform="rotate(-180 602.419 212.241)" fill="#F24C84" />
        <circle cx="594.324" cy="212.241" r="1.5" transform="rotate(-180 594.324 212.241)" fill="#F24C84" />
        <circle cx="586.23" cy="212.241" r="1.5" transform="rotate(-180 586.23 212.241)" fill="#F24C84" />
        <circle cx="578.135" cy="212.241" r="1.5" transform="rotate(-180 578.135 212.241)" fill="#F24C84" />
        <circle cx="570.041" cy="212.241" r="1.5" transform="rotate(-180 570.041 212.241)" fill="#F24C84" />
        <circle cx="561.946" cy="212.241" r="1.5" transform="rotate(-180 561.946 212.241)" fill="#F24C84" />
        <circle cx="553.852" cy="212.241" r="1.5" transform="rotate(-180 553.852 212.241)" fill="#F24C84" />
        <circle cx="545.757" cy="212.241" r="1.5" transform="rotate(-180 545.757 212.241)" fill="#F24C84" />
        <circle cx="537.662" cy="212.241" r="1.5" transform="rotate(-180 537.662 212.241)" fill="#F24C84" />
        <circle cx="529.568" cy="212.241" r="1.5" transform="rotate(-180 529.568 212.241)" fill="#F24C84" />
        <circle cx="521.473" cy="212.241" r="1.5" transform="rotate(-180 521.473 212.241)" fill="#F24C84" />
        <circle cx="513.378" cy="212.241" r="1.5" transform="rotate(-180 513.378 212.241)" fill="#F24C84" />
        <circle cx="505.284" cy="212.241" r="1.5" transform="rotate(-180 505.284 212.241)" fill="#F24C84" />
        <circle cx="497.189" cy="212.241" r="1.5" transform="rotate(-180 497.189 212.241)" fill="#F24C84" />
        <circle cx="489.095" cy="212.241" r="1.5" transform="rotate(-180 489.095 212.241)" fill="#F24C84" />
        <circle cx="481" cy="212.241" r="1.5" transform="rotate(-180 481 212.241)" fill="#F24C84" />
        <circle cx="472.905" cy="212.241" r="1.5" transform="rotate(-180 472.905 212.241)" fill="#F24C84" />
        <circle cx="464.811" cy="212.241" r="1.5" transform="rotate(-180 464.811 212.241)" fill="#F24C84" />
        <circle cx="456.716" cy="212.241" r="1.5" transform="rotate(-180 456.716 212.241)" fill="#F24C84" />
        <circle cx="448.622" cy="212.241" r="1.5" transform="rotate(-180 448.622 212.241)" fill="#F24C84" />
        <circle cx="440.527" cy="212.241" r="1.5" transform="rotate(-180 440.527 212.241)" fill="#F24C84" />
        <circle cx="432.433" cy="212.241" r="1.5" transform="rotate(-180 432.433 212.241)" fill="#F24C84" />
        <circle cx="424.338" cy="212.241" r="1.5" transform="rotate(-180 424.338 212.241)" fill="#F24C84" />
        <circle cx="416.243" cy="212.241" r="1.5" transform="rotate(-180 416.243 212.241)" fill="#F24C84" />
        <circle cx="408.148" cy="212.241" r="1.5" transform="rotate(-180 408.148 212.241)" fill="#F24C84" />
        <circle cx="400.054" cy="212.241" r="1.5" transform="rotate(-180 400.054 212.241)" fill="#F24C84" />
        <circle cx="391.959" cy="212.241" r="1.5" transform="rotate(-180 391.959 212.241)" fill="#F24C84" />
        <circle cx="383.865" cy="212.241" r="1.5" transform="rotate(-180 383.865 212.241)" fill="#F24C84" />
        <circle cx="375.77" cy="212.241" r="1.5" transform="rotate(-180 375.77 212.241)" fill="#F24C84" />
        <circle cx="367.676" cy="212.241" r="1.5" transform="rotate(-180 367.676 212.241)" fill="#F24C84" />
        <circle cx="359.581" cy="212.241" r="1.5" transform="rotate(-180 359.581 212.241)" fill="#F24C84" />
        <circle cx="351.486" cy="212.241" r="1.5" transform="rotate(-180 351.486 212.241)" fill="#F24C84" />
        <circle cx="343.392" cy="212.241" r="1.5" transform="rotate(-180 343.392 212.241)" fill="#F24C84" />
        <circle cx="335.297" cy="212.241" r="1.5" transform="rotate(-180 335.297 212.241)" fill="#F24C84" />
        <circle cx="327.203" cy="212.241" r="1.5" transform="rotate(-180 327.203 212.241)" fill="#F24C84" />
        <circle cx="319.108" cy="212.241" r="1.5" transform="rotate(-180 319.108 212.241)" fill="#F24C84" />
        <circle cx="311.013" cy="212.241" r="1.5" transform="rotate(-180 311.013 212.241)" fill="#F24C84" />
        <circle cx="302.919" cy="212.241" r="1.5" transform="rotate(-180 302.919 212.241)" fill="#F24C84" />
        <circle cx="294.824" cy="212.241" r="1.5" transform="rotate(-180 294.824 212.241)" fill="#F24C84" />
        <circle cx="286.729" cy="212.241" r="1.5" transform="rotate(-180 286.729 212.241)" fill="#F24C84" />
        <circle cx="278.635" cy="212.241" r="1.5" transform="rotate(-180 278.635 212.241)" fill="#F24C84" />
        <circle cx="270.541" cy="212.241" r="1.5" transform="rotate(-180 270.541 212.241)" fill="#F24C84" />
        <circle cx="262.446" cy="212.241" r="1.5" transform="rotate(-180 262.446 212.241)" fill="#F24C84" />
        <circle cx="254.351" cy="212.241" r="1.5" transform="rotate(-180 254.351 212.241)" fill="#F24C84" />
        <circle cx="246.256" cy="212.241" r="1.5" transform="rotate(-180 246.256 212.241)" fill="#F04586" />
        <circle cx="238.162" cy="212.241" r="1.5" transform="rotate(-180 238.162 212.241)" fill="#F04586" />
        <circle cx="230.067" cy="212.241" r="1.5" transform="rotate(-180 230.067 212.241)" fill="#F04586" />
        <circle cx="221.973" cy="212.241" r="1.5" transform="rotate(-180 221.973 212.241)" fill="#F04586" />
        <circle cx="213.878" cy="212.241" r="1.5" transform="rotate(-180 213.878 212.241)" fill="#F04586" />
        <circle cx="205.784" cy="212.241" r="1.5" transform="rotate(-180 205.784 212.241)" fill="#F04586" />
        <circle cx="197.689" cy="212.241" r="1.5" transform="rotate(-180 197.689 212.241)" fill="#F04586" />
        <circle cx="189.594" cy="212.241" r="1.5" transform="rotate(-180 189.594 212.241)" fill="#F04586" />
        <circle cx="181.5" cy="212.241" r="1.5" transform="rotate(-180 181.5 212.241)" fill="#F04586" />
      </mask>
      <g mask="url(#mask0_2361_6318)">
        <rect
          x="807.477"
          y="175.315"
          width="105.384"
          height="628.42"
          transform="rotate(90 807.477 175.315)"
          fill="url(#paint3_linear_2361_6318)"
        />
      </g>
      <mask
        id="mask1_2361_6318"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="631"
        y="409"
        width="4"
        height="726"
      >
        <circle cx="632.8" cy="411.019" r="1.5" transform="rotate(90 632.8 411.019)" fill="#F24C84" />
        <circle cx="632.8" cy="420.782" r="1.5" transform="rotate(90 632.8 420.782)" fill="#F24C84" />
        <circle cx="632.8" cy="430.545" r="1.5" transform="rotate(90 632.8 430.545)" fill="#F24C84" />
        <circle cx="632.8" cy="440.308" r="1.5" transform="rotate(90 632.8 440.308)" fill="#F24C84" />
        <circle cx="632.8" cy="450.072" r="1.5" transform="rotate(90 632.8 450.072)" fill="#F24C84" />
        <circle cx="632.8" cy="459.835" r="1.5" transform="rotate(90 632.8 459.835)" fill="#F24C84" />
        <circle cx="632.8" cy="469.598" r="1.5" transform="rotate(90 632.8 469.598)" fill="#F24C84" />
        <circle cx="632.8" cy="479.361" r="1.5" transform="rotate(90 632.8 479.361)" fill="#F24C84" />
        <circle cx="632.8" cy="489.125" r="1.5" transform="rotate(90 632.8 489.125)" fill="#F24C84" />
        <circle cx="632.8" cy="498.888" r="1.5" transform="rotate(90 632.8 498.888)" fill="#F24C84" />
        <circle cx="632.8" cy="508.651" r="1.5" transform="rotate(90 632.8 508.651)" fill="#F24C84" />
        <circle cx="632.8" cy="518.415" r="1.5" transform="rotate(90 632.8 518.415)" fill="#F24C84" />
        <circle cx="632.8" cy="528.178" r="1.5" transform="rotate(90 632.8 528.178)" fill="#F24C84" />
        <circle cx="632.8" cy="537.941" r="1.5" transform="rotate(90 632.8 537.941)" fill="#F24C84" />
        <circle cx="632.8" cy="547.704" r="1.5" transform="rotate(90 632.8 547.704)" fill="#F24C84" />
        <circle cx="632.8" cy="557.467" r="1.5" transform="rotate(90 632.8 557.467)" fill="#F24C84" />
        <circle cx="632.8" cy="567.23" r="1.5" transform="rotate(90 632.8 567.23)" fill="#F24C84" />
        <circle cx="632.8" cy="576.994" r="1.5" transform="rotate(90 632.8 576.994)" fill="#F24C84" />
        <circle cx="632.8" cy="586.757" r="1.5" transform="rotate(90 632.8 586.757)" fill="#F24C84" />
        <circle cx="632.8" cy="596.521" r="1.5" transform="rotate(90 632.8 596.521)" fill="#F24C84" />
        <circle cx="632.8" cy="606.284" r="1.5" transform="rotate(90 632.8 606.284)" fill="#F24C84" />
        <circle cx="632.8" cy="616.047" r="1.5" transform="rotate(90 632.8 616.047)" fill="#F24C84" />
        <circle cx="632.8" cy="625.81" r="1.5" transform="rotate(90 632.8 625.81)" fill="#F24C84" />
        <circle cx="632.8" cy="635.574" r="1.5" transform="rotate(90 632.8 635.574)" fill="#F24C84" />
        <circle cx="632.8" cy="645.337" r="1.5" transform="rotate(90 632.8 645.337)" fill="#F24C84" />
        <circle cx="632.8" cy="655.1" r="1.5" transform="rotate(90 632.8 655.1)" fill="#F24C84" />
        <circle cx="632.8" cy="664.863" r="1.5" transform="rotate(90 632.8 664.863)" fill="#F24C84" />
        <circle cx="632.8" cy="674.626" r="1.5" transform="rotate(90 632.8 674.626)" fill="#F24C84" />
        <circle cx="632.8" cy="684.39" r="1.5" transform="rotate(90 632.8 684.39)" fill="#F24C84" />
        <circle cx="632.8" cy="694.153" r="1.5" transform="rotate(90 632.8 694.153)" fill="#F24C84" />
        <circle cx="632.8" cy="703.917" r="1.5" transform="rotate(90 632.8 703.917)" fill="#F24C84" />
        <circle cx="632.8" cy="713.68" r="1.5" transform="rotate(90 632.8 713.68)" fill="#F24C84" />
        <circle cx="632.8" cy="723.443" r="1.5" transform="rotate(90 632.8 723.443)" fill="#F24C84" />
        <circle cx="632.8" cy="733.206" r="1.5" transform="rotate(90 632.8 733.206)" fill="#F24C84" />
        <circle cx="632.8" cy="742.969" r="1.5" transform="rotate(90 632.8 742.969)" fill="#F24C84" />
        <circle cx="632.8" cy="752.732" r="1.5" transform="rotate(90 632.8 752.732)" fill="#F24C84" />
        <circle cx="632.8" cy="762.496" r="1.5" transform="rotate(90 632.8 762.496)" fill="#F24C84" />
        <circle cx="632.8" cy="772.259" r="1.5" transform="rotate(90 632.8 772.259)" fill="#F24C84" />
        <circle cx="632.8" cy="782.022" r="1.5" transform="rotate(90 632.8 782.022)" fill="#F24C84" />
        <circle cx="632.8" cy="791.786" r="1.5" transform="rotate(90 632.8 791.786)" fill="#F24C84" />
        <circle cx="632.8" cy="801.549" r="1.5" transform="rotate(90 632.8 801.549)" fill="#F24C84" />
        <circle cx="632.8" cy="811.312" r="1.5" transform="rotate(90 632.8 811.312)" fill="#F24C84" />
        <circle cx="632.8" cy="821.075" r="1.5" transform="rotate(90 632.8 821.075)" fill="#F24C84" />
        <circle cx="632.8" cy="830.838" r="1.5" transform="rotate(90 632.8 830.838)" fill="#F24C84" />
        <circle cx="632.8" cy="840.602" r="1.5" transform="rotate(90 632.8 840.602)" fill="#F24C84" />
        <circle cx="632.8" cy="850.365" r="1.5" transform="rotate(90 632.8 850.365)" fill="#F24C84" />
        <circle cx="632.8" cy="860.128" r="1.5" transform="rotate(90 632.8 860.128)" fill="#F24C84" />
        <circle cx="632.8" cy="869.892" r="1.5" transform="rotate(90 632.8 869.892)" fill="#F24C84" />
        <circle cx="632.8" cy="879.655" r="1.5" transform="rotate(90 632.8 879.655)" fill="#F24C84" />
        <circle cx="632.8" cy="889.418" r="1.5" transform="rotate(90 632.8 889.418)" fill="#F24C84" />
        <circle cx="632.8" cy="899.181" r="1.5" transform="rotate(90 632.8 899.181)" fill="#F24C84" />
        <circle cx="632.8" cy="908.944" r="1.5" transform="rotate(90 632.8 908.944)" fill="#F24C84" />
        <circle cx="632.8" cy="918.708" r="1.5" transform="rotate(90 632.8 918.708)" fill="#F24C84" />
        <circle cx="632.8" cy="928.471" r="1.5" transform="rotate(90 632.8 928.471)" fill="#F24C84" />
        <circle cx="632.8" cy="938.234" r="1.5" transform="rotate(90 632.8 938.234)" fill="#F24C84" />
        <circle cx="632.8" cy="947.998" r="1.5" transform="rotate(90 632.8 947.998)" fill="#F24C84" />
        <circle cx="632.8" cy="957.761" r="1.5" transform="rotate(90 632.8 957.761)" fill="#F24C84" />
        <circle cx="632.8" cy="967.524" r="1.5" transform="rotate(90 632.8 967.524)" fill="#F24C84" />
        <circle cx="632.8" cy="977.287" r="1.5" transform="rotate(90 632.8 977.287)" fill="#F24C84" />
        <circle cx="632.8" cy="987.05" r="1.5" transform="rotate(90 632.8 987.05)" fill="#F24C84" />
        <circle cx="632.8" cy="996.813" r="1.5" transform="rotate(90 632.8 996.813)" fill="#F24C84" />
        <circle cx="632.8" cy="1006.58" r="1.5" transform="rotate(90 632.8 1006.58)" fill="#F24C84" />
        <circle cx="632.8" cy="1016.34" r="1.5" transform="rotate(90 632.8 1016.34)" fill="#F24C84" />
        <circle cx="632.8" cy="1026.1" r="1.5" transform="rotate(90 632.8 1026.1)" fill="#F24C84" />
        <circle cx="632.8" cy="1035.87" r="1.5" transform="rotate(90 632.8 1035.87)" fill="#F24C84" />
        <circle cx="632.8" cy="1045.63" r="1.5" transform="rotate(90 632.8 1045.63)" fill="#F24C84" />
        <circle cx="632.8" cy="1055.39" r="1.5" transform="rotate(90 632.8 1055.39)" fill="#F04586" />
        <circle cx="632.8" cy="1065.16" r="1.5" transform="rotate(90 632.8 1065.16)" fill="#F04586" />
        <circle cx="632.8" cy="1074.92" r="1.5" transform="rotate(90 632.8 1074.92)" fill="#F04586" />
      </mask>
      <g mask="url(#mask1_2361_6318)">
        <rect x="588.3" y="478.816" width="127" height="757.32" fill="url(#paint4_linear_2361_6318)" />
      </g>
      <mask
        id="mask2_2361_6318"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="706"
        y="-277"
        width="4"
        height="726"
      >
        <circle cx="707.8" cy="7.63428" r="1.5" transform="rotate(90 707.8 7.63428)" fill="#F24C84" />
        <circle cx="707.8" cy="17.3979" r="1.5" transform="rotate(90 707.8 17.3979)" fill="#F24C84" />
        <circle cx="707.8" cy="27.1611" r="1.5" transform="rotate(90 707.8 27.1611)" fill="#F24C84" />
        <circle cx="707.8" cy="36.9243" r="1.5" transform="rotate(90 707.8 36.9243)" fill="#F24C84" />
        <circle cx="707.8" cy="46.6875" r="1.5" transform="rotate(90 707.8 46.6875)" fill="#F24C84" />
        <circle cx="707.8" cy="56.4507" r="1.5" transform="rotate(90 707.8 56.4507)" fill="#F24C84" />
        <circle cx="707.8" cy="66.2139" r="1.5" transform="rotate(90 707.8 66.2139)" fill="#F24C84" />
        <circle cx="707.8" cy="75.9771" r="1.5" transform="rotate(90 707.8 75.9771)" fill="#F24C84" />
        <circle cx="707.8" cy="85.7402" r="1.5" transform="rotate(90 707.8 85.7402)" fill="#F24C84" />
        <circle cx="707.8" cy="95.5039" r="1.5" transform="rotate(90 707.8 95.5039)" fill="#F24C84" />
        <circle cx="707.8" cy="105.267" r="1.5" transform="rotate(90 707.8 105.267)" fill="#F24C84" />
        <circle cx="707.8" cy="115.03" r="1.5" transform="rotate(90 707.8 115.03)" fill="#F24C84" />
        <circle cx="707.8" cy="124.793" r="1.5" transform="rotate(90 707.8 124.793)" fill="#F24C84" />
        <circle cx="707.8" cy="134.557" r="1.5" transform="rotate(90 707.8 134.557)" fill="#F24C84" />
        <circle cx="707.8" cy="144.32" r="1.5" transform="rotate(90 707.8 144.32)" fill="#F24C84" />
        <circle cx="707.8" cy="154.083" r="1.5" transform="rotate(90 707.8 154.083)" fill="#F24C84" />
        <circle cx="707.8" cy="163.846" r="1.5" transform="rotate(90 707.8 163.846)" fill="#F24C84" />
        <circle cx="707.8" cy="173.61" r="1.5" transform="rotate(90 707.8 173.61)" fill="#F24C84" />
        <circle cx="707.8" cy="183.373" r="1.5" transform="rotate(90 707.8 183.373)" fill="#F24C84" />
        <circle cx="707.8" cy="193.136" r="1.5" transform="rotate(90 707.8 193.136)" fill="#F24C84" />
        <circle cx="707.8" cy="202.899" r="1.5" transform="rotate(90 707.8 202.899)" fill="#F24C84" />
        <circle cx="707.8" cy="212.663" r="1.5" transform="rotate(90 707.8 212.663)" fill="#F24C84" />
        <circle cx="707.8" cy="222.426" r="1.5" transform="rotate(90 707.8 222.426)" fill="#F24C84" />
        <circle cx="707.8" cy="232.189" r="1.5" transform="rotate(90 707.8 232.189)" fill="#F24C84" />
        <circle cx="707.8" cy="241.952" r="1.5" transform="rotate(90 707.8 241.952)" fill="#F24C84" />
        <circle cx="707.8" cy="251.716" r="1.5" transform="rotate(90 707.8 251.716)" fill="#F24C84" />
        <circle cx="707.8" cy="261.479" r="1.5" transform="rotate(90 707.8 261.479)" fill="#F24C84" />
        <circle cx="707.8" cy="271.242" r="1.5" transform="rotate(90 707.8 271.242)" fill="#F24C84" />
        <circle cx="707.8" cy="281.005" r="1.5" transform="rotate(90 707.8 281.005)" fill="#F24C84" />
        <circle cx="707.8" cy="290.769" r="1.5" transform="rotate(90 707.8 290.769)" fill="#F24C84" />
        <circle cx="707.8" cy="300.532" r="1.5" transform="rotate(90 707.8 300.532)" fill="#F24C84" />
        <circle cx="707.8" cy="310.295" r="1.5" transform="rotate(90 707.8 310.295)" fill="#F24C84" />
        <circle cx="707.8" cy="320.059" r="1.5" transform="rotate(90 707.8 320.059)" fill="#F24C84" />
        <circle cx="707.8" cy="329.822" r="1.5" transform="rotate(90 707.8 329.822)" fill="#F24C84" />
        <circle cx="707.8" cy="339.585" r="1.5" transform="rotate(90 707.8 339.585)" fill="#F24C84" />
        <circle cx="707.8" cy="349.348" r="1.5" transform="rotate(90 707.8 349.348)" fill="#F24C84" />
        <circle cx="707.8" cy="359.111" r="1.5" transform="rotate(90 707.8 359.111)" fill="#F24C84" />
        <circle cx="707.8" cy="368.875" r="1.5" transform="rotate(90 707.8 368.875)" fill="#F04586" />
        <circle cx="707.8" cy="378.638" r="1.5" transform="rotate(90 707.8 378.638)" fill="#F04586" />
        <circle cx="707.8" cy="388.401" r="1.5" transform="rotate(90 707.8 388.401)" fill="#F04586" />
        <circle cx="707.8" cy="398.164" r="1.5" transform="rotate(90 707.8 398.164)" fill="#F04586" />
        <circle cx="707.8" cy="407.928" r="1.5" transform="rotate(90 707.8 407.928)" fill="#F04586" />
        <circle cx="707.8" cy="417.691" r="1.5" transform="rotate(90 707.8 417.691)" fill="#F04586" />
        <circle cx="707.8" cy="427.454" r="1.5" transform="rotate(90 707.8 427.454)" fill="#F04586" />
        <circle cx="707.8" cy="437.217" r="1.5" transform="rotate(90 707.8 437.217)" fill="#F04586" />
        <circle cx="707.8" cy="446.98" r="1.5" transform="rotate(90 707.8 446.98)" fill="#F04586" />
      </mask>
      <g mask="url(#mask2_2361_6318)">
        <rect x="663.3" y="-307.702" width="127" height="757.32" fill="url(#paint5_linear_2361_6318)" />
      </g>
      <path
        d="M160 382.902V347.335V347.335C160 346.874 160.374 346.5 160.835 346.5H195.611"
        stroke="url(#paint6_linear_2361_6318)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M543.905 346.5H579.516V346.5C579.978 346.5 580.352 346.874 580.352 347.336V382.067"
        stroke="url(#paint7_linear_2361_6318)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M580.352 729.98V765.547V765.547C580.352 766.009 579.978 766.382 579.517 766.382H544.741"
        stroke="url(#paint8_linear_2361_6318)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M196.447 766.382H160.836V766.382C160.374 766.382 160 766.008 160 765.547V730.815"
        stroke="url(#paint9_linear_2361_6318)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M373 311.5L373 271.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M372.866 803.538V843.538" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M620 556.5L690 556.5" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M126 557.123H56" stroke="#CC44D8" strokeWidth="1.5" strokeMiterlimit="10" />
      <g filter="url(#filter4_d_2361_6318)">
        <path
          d="M592.516 697.299C591.51 697.757 590.32 697.314 589.903 696.291C586.444 687.806 585.39 678.516 586.876 669.447C588.471 659.72 592.918 650.685 599.653 643.487C606.388 636.29 615.109 631.254 624.709 629.018C634.31 626.782 644.358 627.447 653.58 630.928C662.802 634.409 670.783 640.55 676.511 648.572C682.24 656.594 685.458 666.136 685.757 675.989C686.056 685.842 683.423 695.562 678.192 703.917C673.316 711.706 666.386 717.981 658.182 722.065C657.193 722.557 656.007 722.103 655.555 721.095L647.053 702.14C646.601 701.132 647.056 699.956 648.024 699.424C651.76 697.375 654.921 694.4 657.194 690.77C659.821 686.573 661.144 681.69 660.994 676.741C660.843 671.792 659.227 666.999 656.349 662.969C653.472 658.94 649.463 655.855 644.831 654.106C640.198 652.358 635.151 652.024 630.328 653.147C625.506 654.27 621.126 656.8 617.742 660.415C614.359 664.03 612.126 668.569 611.324 673.455C610.632 677.682 611.038 682.004 612.488 686.01C612.864 687.049 612.428 688.233 611.423 688.69L592.516 697.299Z"
          fill="url(#paint10_linear_2361_6318)"
          fillOpacity="0.6"
        />
        <path
          d="M653.554 721.939C653.96 722.966 653.457 724.132 652.414 724.496C642.567 727.935 631.886 728.194 621.884 725.237C620.825 724.923 620.266 723.783 620.622 722.737L627.345 702.959C627.701 701.913 628.836 701.362 629.907 701.633C634.303 702.743 638.92 702.631 643.257 701.309C644.313 700.987 645.473 701.482 645.879 702.51L653.554 721.939Z"
          fill="url(#paint11_linear_2361_6318)"
          fillOpacity="0.6"
        />
        <path
          d="M618.708 722.041C618.308 723.071 617.147 723.585 616.135 723.144C606.093 718.774 597.771 711.212 592.462 701.634C591.926 700.668 592.327 699.463 593.314 698.967L611.977 689.581C612.964 689.085 614.159 689.488 614.733 690.432C617.223 694.527 620.844 697.817 625.159 699.905C626.153 700.386 626.668 701.538 626.268 702.567L618.708 722.041Z"
          fill="url(#paint12_linear_2361_6318)"
          fillOpacity="0.6"
        />
      </g>
      <rect
        x="169.75"
        y="355.25"
        width="32.5"
        height="32.5"
        rx="1.25"
        stroke="url(#paint13_linear_2361_6318)"
        strokeWidth="1.5"
      />
      <rect
        x="540.75"
        y="726.25"
        width="32.5"
        height="32.5"
        rx="1.25"
        stroke="url(#paint14_linear_2361_6318)"
        strokeWidth="1.5"
      />
      <mask id="path-224-inside-6_2361_6318" fill="white">
        <path d="M372.5 340.5C372.5 338.291 374.291 336.496 376.5 336.536C421.448 337.355 465.097 351.959 501.519 378.421C537.94 404.883 565.318 441.883 579.986 484.378C580.707 486.466 579.554 488.724 577.453 489.407L501.88 513.962C499.779 514.644 497.529 513.492 496.783 511.412C487.839 486.481 471.589 464.783 450.11 449.179C428.632 433.574 402.975 424.824 376.5 424.022C374.292 423.955 372.5 422.171 372.5 419.961L372.5 340.5Z" />
      </mask>
      <path
        d="M372.5 340.5C372.5 338.291 374.291 336.496 376.5 336.536C421.448 337.355 465.097 351.959 501.519 378.421C537.94 404.883 565.318 441.883 579.986 484.378C580.707 486.466 579.554 488.724 577.453 489.407L501.88 513.962C499.779 514.644 497.529 513.492 496.783 511.412C487.839 486.481 471.589 464.783 450.11 449.179C428.632 433.574 402.975 424.824 376.5 424.022C374.292 423.955 372.5 422.171 372.5 419.961L372.5 340.5Z"
        fill="#694DBE"
        stroke="#483389"
        strokeWidth="2"
        mask="url(#path-224-inside-6_2361_6318)"
      />
      <g filter="url(#filter5_d_2361_6318)">
        <circle
          cx="111"
          cy="470.5"
          r="42"
          fill="url(#paint15_linear_2361_6318)"
          fillOpacity="0.6"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2361_6318"
          x="173.255"
          y="357.485"
          width="407.99"
          height="406.029"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9" dy="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6318" result="shape" />
        </filter>
        <filter
          id="filter1_d_2361_6318"
          x="4.5"
          y="595.5"
          width="150"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6318" result="shape" />
        </filter>
        <filter
          id="filter2_d_2361_6318"
          x="442.5"
          y="791.5"
          width="147"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6318" result="shape" />
        </filter>
        <filter
          id="filter3_d_2361_6318"
          x="452.5"
          y="249.5"
          width="194"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.19 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6318" result="shape" />
        </filter>
        <filter
          id="filter4_d_2361_6318"
          x="586.22"
          y="627.721"
          width="107.56"
          height="107.559"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6318" result="shape" />
        </filter>
        <filter
          id="filter5_d_2361_6318"
          x="69"
          y="428.5"
          width="92"
          height="92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2361_6318" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2361_6318" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2361_6318"
          x1="4.28227"
          y1="595.273"
          x2="171.784"
          y2="626.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2361_6318"
          x1="442.287"
          y1="791.273"
          x2="606.478"
          y2="821.095"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2361_6318"
          x1="452.215"
          y1="249.273"
          x2="666.514"
          y2="301.357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2361_6318"
          x1="855.19"
          y1="404.604"
          x2="962.195"
          y2="437.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2361_6318"
          x1="652.3"
          y1="614"
          x2="816.584"
          y2="664.654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5A5A" stopOpacity="0" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2361_6318"
          x1="720.8"
          y1="-31.3825"
          x2="849.753"
          y2="8.56085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA627A" stopOpacity="0.22" />
          <stop offset="0.375" stopColor="#EE4486" stopOpacity="0.51" />
          <stop offset="0.729167" stopColor="#BE6EFE" stopOpacity="0.33" />
          <stop offset="1" stopColor="#676CF4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2361_6318"
          x1="159.945"
          y1="346.367"
          x2="203.127"
          y2="349.789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2361_6318"
          x1="543.849"
          y1="346.37"
          x2="588.018"
          y2="350.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2361_6318"
          x1="544.687"
          y1="729.847"
          x2="587.868"
          y2="733.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2361_6318"
          x1="159.944"
          y1="730.685"
          x2="204.112"
          y2="734.352"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2361_6318"
          x1="654.459"
          y1="609.186"
          x2="706.337"
          y2="718.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2361_6318"
          x1="654.459"
          y1="609.186"
          x2="706.337"
          y2="718.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2361_6318"
          x1="654.459"
          y1="609.186"
          x2="706.337"
          y2="718.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2361_6318"
          x1="168.948"
          y1="354.376"
          x2="210.164"
          y2="357.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2361_6318"
          x1="539.948"
          y1="725.376"
          x2="581.164"
          y2="728.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2361_6318"
          x1="68.8712"
          y1="428.193"
          x2="170.7"
          y2="436.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6C87" />
          <stop offset="0.59375" stopColor="#B556FF" />
          <stop offset="1" stopColor="#6E3AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
